import { useState } from 'react';
import { BsCircleFill } from 'react-icons/bs';
import {
  Button,
  Pagination,
  Popover,
  Stack,
  Table,
  Tooltip,
  Whisper
} from 'rsuite';
import '../styles/DeviceStatus.scss';
import { DraggableDrawer } from './DraggableDrawer';
import { t } from 'i18next';
interface IProps {
  deviceData: Record<string, any>[];
  device_status: string;
  device_num: number;
}

interface GetDataProps {
  deviceData: Record<string, any>[];
  device_status: string;
}
const { Column, HeaderCell, Cell } = Table;

const StatusTable = ({ deviceData, device_status }: GetDataProps) => {
  const limits = [15, 30, 50, 100];
  const [limit, setLimit] = useState<number>(limits[0]);
  const [page, setPage] = useState<number>(1);

  const data = deviceData.filter((v: Record<string, any>, i: number) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = async (pageSize: number) => {
    setPage(1);
    setLimit(pageSize);
  };
  const handleChangePage = async (page: number) => {
    setPage(page);
  };
  return (
    <>
      <div style={{ height: '90%' }}>
        <Table rowKey="value" data={data} height={200} fillHeight>
          <Column
            align="left"
            verticalAlign="middle"
            width={200}
            minWidth={200}
            flexGrow={1}
          >
            <HeaderCell>{t('common.deviceStatusDialog.sn')}</HeaderCell>
            <Cell dataKey="SN" />
          </Column>
          <Column
            width={100}
            minWidth={100}
            flexGrow={0.5}
            align="left"
            verticalAlign="middle"
          >
            <HeaderCell>{t('common.deviceStatusDialog.status')}</HeaderCell>
            <Cell dataKey="status">
              {(data: Record<string, any>) => (
                <span
                  style={{
                    color: device_status === 'inactive' ? 'red' : 'green'
                  }}
                >
                  {data?.status === 'Active'
                    ? t('common.deviceStatusDialog.active')
                    : t('common.deviceStatusDialog.inactive')}
                </span>
              )}
            </Cell>
          </Column>
        </Table>
      </div>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={deviceData.length}
          limit={limit}
          limitOptions={limits}
          activePage={page}
          onChangePage={handleChangePage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </>
  );
};

export const DeviceStatus = ({
  deviceData,
  device_status,
  device_num
}: IProps) => {
  const [openDetail, setOpenDetail] = useState<boolean>(false);
  const rare = device_num > 3 ? 3 : device_num;
  let tooltipData: string = '';
  for (let i = 0; i < rare; ++i) {
    tooltipData = tooltipData.concat(deviceData[i].SN, '\n');
  }
  return deviceData ? (
    <div style={{ marginRight: '8px' }}>
      <Stack>
        <Whisper
          placement="top"
          trigger="hover"
          enterable={true}
          speaker={
            <Popover className="device-status">
              <Stack>
                <div>
                  <span className="tooltip-data">
                    {device_status === 'inactive' ? (
                      <p>
                        {t('common.deviceStatusDialog.tooltipTitleInactive')}
                      </p>
                    ) : (
                      <p>{t('common.deviceStatusDialog.tooltipTitleActive')}</p>
                    )}
                    {tooltipData}
                  </span>
                  {device_num > 3 && (
                    <Button
                      appearance="link"
                      size="xs"
                      className="device-status-button"
                      onClick={() => {
                        setOpenDetail(true);
                      }}
                    >
                      {t('common.deviceStatusDialog.tooltipLoadMore')}
                    </Button>
                  )}
                </div>
              </Stack>
            </Popover>
          }
        >
          <Stack>
            <BsCircleFill
              fontSize="0.6em"
              color={device_status === 'inactive' ? 'red' : 'green'}
            ></BsCircleFill>
            {device_num}
          </Stack>
        </Whisper>
        <DraggableDrawer
          className="api-portal-drawer"
          open={openDetail}
          setOpen={setOpenDetail}
          size="lg"
          title={<b>{t('common.deviceStatusDialog.title')}</b>}
        >
          <StatusTable deviceData={deviceData} device_status={device_status} />
        </DraggableDrawer>
      </Stack>
    </div>
  ) : (
    <></>
  );
};
